// ==============================|| SIGNÁL VYPRŠELÉ SESSION ||============================== //
// 2026-09-04, bugfix: dřív při vypršelé session uprostřed používání appka
// jen zobrazila chybovou hlášku z API ("Přihlášení je vyžadováno.") místo
// přesměrování na /login. AuthGuard (utils/route-guard/AuthGuard.jsx) už
// umí přesměrovat na /login se zapamatovaným state.from a po úspěšném
// přihlášení se AuthLogin.jsx vrátí zpátky - ale jen reaguje na
// AuthContext's status, který se mimo počáteční /auth/me kontrolu sám od
// sebe neaktualizuje. Tenhle modul dá desítkám nezávislých api/*.js
// apiGet/apiPost helperů způsob, jak AuthContext o 401 uprostřed session
// informovat, aniž by musely importovat React kontext přímo.

let handler = null;

export function registerSessionExpiredHandler(fn) {
  handler = fn;
}

export function notifySessionExpired() {
  if (handler) handler();
}
